export enum MarkerIconSize {
  default = 24,
  destination = 33,
}
